import React, { FC } from "react";
import { IPrincipleItem } from "./types";

interface Props extends IPrincipleItem {}

export const PrincipleItem: FC<Props> = ({
  title,
  description,
  icon: Icon,
}) => (
  <div className="flex flex-col gap-2 4xl:gap-4.25 xl:max-w-80 w-full text-white-base">
    <Icon className="w-6 h-6 xl:w-10 xl:h-10 4xl:w-12.5 4xl:h-12.5" />

    <h4 className="break-all font-semibold text-lg 4xl:text-24">{title}</h4>

    <p className="text-xs whitespace-break-spaces 3xl:text-sm 4xl:text-base">
      {description}
    </p>
  </div>
);
